import { Injectable, signal, WritableSignal } from '@angular/core';

export interface IAlbum {
  src: string;
  thumb?: string;
  caption?: string | number;
}

@Injectable({ providedIn: 'root' })
export class Lightbox {

  readonly album: WritableSignal<IAlbum[]> = signal<IAlbum[]>([]);
  readonly index: WritableSignal<number> = signal<number>(0);
  readonly isOpen: WritableSignal<boolean> = signal<boolean>(false);

  open(album: IAlbum[], index: number = 0): void {
    if (!album || album.length === 0) {
      return;
    }

    this.album.set(album);
    this.index.set(Math.min(Math.max(index, 0), album.length - 1));
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
  }

  next(): void {
    const length: number = this.album().length;

    if (length > 0) {
      this.index.update((i: number): number => (i + 1) % length);
    }
  }

  prev(): void {
    const length: number = this.album().length;

    if (length > 0) {
      this.index.update((i: number): number => (i - 1 + length) % length);
    }
  }
}
